import { createActionType, createRequestTypes } from 'app/lib/actionTypes';

export const TIME_SLOTS = createRequestTypes('TIME_SLOTS');
export const VISITS = createRequestTypes('VISITS');
export const VISIT = createRequestTypes('VISIT');
export const SUBMIT_VISIT = createRequestTypes('SUBMIT_VISIT');
export const GET_VISIT = createRequestTypes('GET_VISIT');
export const STORE_VISIT = createRequestTypes('STORE_VISIT');
export const GET_UNITS = createRequestTypes('GET_UNITS');
export const STORE_UNIT = createRequestTypes('STORE_UNIT');
export const DELETE_VISIT = createRequestTypes('DELETE_VISIT');
export const DELETE_UNIT = createRequestTypes('DELETE_UNIT');
export const VERIFY_UNIT = Object.assign(
    createRequestTypes('VERIFY_UNIT'), {
    RESET: createActionType('VERIFY_UNIT_RESET')
});
export const VISIT_AND_UNITS = Object.assign(
    createRequestTypes('VISIT_AND_UNITS'), {
    CLEAR: createActionType('VISIT_AND_UNITS_CLEAR')
});

export const GET_GOODS = createRequestTypes('GET_GOODS');
export const STORE_GOOD = createRequestTypes('STORE_GOOD');
export const DELETE_GOOD = createRequestTypes('DELETE_GOOD');


export const GET_DOCS = createRequestTypes('GET_DOCS');
export const STORE_DOC = createRequestTypes('STORE_DOC');
export const DELETE_DOC = createRequestTypes('DELETE_DOC');

export const DOCS_AND_GOODS = {
    CLEAR: createActionType('DOCS_AND_GOODS_CLEAR')    
};

export const VISIT_FETCH_SUCCESS = 'VISIT_FETCH_SUCCESS';

export const VISIT_STORE_REQUEST = 'VISIT_STORE_REQUEST';
export const VISIT_STORE_FAILURE = 'VISIT_STORE_FAILURE';
export const VISIT_STORE_SUCCESS = 'VISIT_STORE_SUCCESS';
